import { useStyle } from '@/classify';
import { gql } from '@apollo/client';
import Link from 'next/link';
import BannerSlider from './bannerSlider';
import defaultClasses from './cartEmpty.module.css';

export const queryCategoryUrl = gql`
  query MiniCartQuery($cartId: String!) {
    cart(cart_id: $cartId) {
      id
      rand_category_url
      __typename
    }
  }
`;

export const CartEmptyCloneFor404 = props => {
  const { setIsOpen, cartBanners, isMiniCart = false, onlyShowCartBanner = false } = props;
  const classes = useStyle(defaultClasses, props.classes);

  return (
    <div className=''>
      {!onlyShowCartBanner && (
        <div className={classes.emptyMessage}>
          <span>Oh, you don't have items in your cart.</span>
        </div>
      )}
      {!onlyShowCartBanner && (
        <div className={classes.buttonsContainer}>
          <Link
            className={classes.linkButton}
            onClick={() => {
              setIsOpen && setIsOpen(false);
            }}
            href={'/mens-boots'}
          >
            Shop Men's Boots
          </Link>
          <Link
            className={classes.linkButton}
            onClick={() => {
              setIsOpen && setIsOpen(false);
            }}
            href={'/womens-boots'}
          >
            Shop Women's Boots
          </Link>
          <Link
            className={classes.linkButton}
            onClick={() => {
              setIsOpen && setIsOpen(false);
            }}
            href={'/kids-boots'}
          >
            Shop Kid's Boots
          </Link>
          <Link
            href={'/waders'}
            className={classes.linkButton}
            onClick={() => {
              setIsOpen && setIsOpen(false);
            }}
          >
            Shop Waders
          </Link>
          <Link
            href={'/apparel'}
            className={classes.linkButton}
            onClick={() => {
              setIsOpen && setIsOpen(false);
            }}
          >
            Shop Apparel
          </Link>
          {/* 每次都全屏 Rerender 保证随机 */}
          {/* <span
            className={[classes.linkButton, classes.linkLast].join(' ')}
            onClick={e => {
              const link = document.createElement('a');

              link.href = `${window.location.origin}/womens-boots`;
              link.click();
              link.remove();
              setIsOpen && setIsOpen(false);
            }}
          >
            <p>I'm feeling lucky!</p>
            <p className={classes.directedToRandomProduct}>(You will be directed to a random collection page!)</p>
          </span> */}
        </div>
      )}

      {cartBanners?.length > 0 && (
        <BannerSlider
          cartBanners={cartBanners}
          isMiniCart={isMiniCart}
        />
      )}
    </div>
  );
};
